import React, { useState } from 'react'
import injectStyles from 'react-jss'
import cn from 'classnames'

import Box from '@material-ui/core/Box'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'

import { SectionTitle } from 'Components/Section/SectionTitle'

import styles from './styles.js'

const ExpandCollapseBox = ({ classes, title, children }) => {
  const [isCollapsed, setIsCollapsed] = useState(false)

  return (
    <Box className={classes.wrapper}>
      <Box
        className={classes.title}
        onClick={() => setIsCollapsed(!isCollapsed)}
      >
        <ExpandMoreIcon
          fontSize="large"
          className={cn(
            classes.expandIcon,
            isCollapsed ? classes.collapsedIcon : {},
          )}
        />
        <SectionTitle>{title}</SectionTitle>
      </Box>
      <Box
        className={cn(
          classes.content,
          isCollapsed ? classes.collapsedContent : {},
        )}
      >
        {children}
      </Box>
    </Box>
  )
}

export default injectStyles(styles)(ExpandCollapseBox)
